// 退货杂单列表查询
const QueryForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    formData:{},
    formField:[
        // {
        //     // name:'order.orderSource', // 订单名称
        //     key:'order_name',
        //     type:'input',
        //     width:'330px',
        //     allowClear:true,
        //     placeholder:'order.orderName',
        // },
        {
            // name:'order.orderSource', // 退货单号
            key:'back_number',
            type:'input',
            width:'200px',
            allowClear:true,
            placeholder:'order.backNumber',
        },
        {
            // name:'order.deliverStatus', // 退货状态
            key:'status',
            type:'select',
            allowClear:true,
            width:'200px',
            optionToLocale:true,
            placeholder:'stock.returnStatus',
            options:[
                {
                    value:1,
                    label:'order.returning'
                },
                {
                    value:2,
                    label:'order.returnSuccessful'
                },
            ]
        },
        {
            // name:'order.orderSource', // sku
            key:'sku',
            type:'select',
            width:'200px',
            allowClear:true,
            placeholder:'order.sku',
            options:[],
        },
        // {
        //     // name:'order.customerType', // 客户
        //     key:'customer_id',
        //     type:'select',
        //     allowClear:true,
        //     width:'330px',
        //     placeholder:'order.customerName',
        //     options:[]
        // },
        // {
        //     // name:'order.customerType', // 备注
        //     key:'remark',
        //     type:'input',
        //     allowClear:true,
        //     width:'330px',
        //     placeholder:'order.instruction',
        // },
        
        {
            // name:'order.customerType', // 创建人
            key:'create_by',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.createUser',
            options:[]
        },
        {
            name:'', // 退货时间
            key:'back_timestamp',
            type:'dateRange',
            allowClear:true,
            width:'330px',
            placeholder1:'stock.planReturnStartDate',
            placeholder2:'stock.planReturnEndDate',
        },
        {
            name:'', // 退货实际到货时间
            key:'back_real_timestamp',
            type:'dateRange',
            allowClear:true,
            width:'330px',
            placeholder1:'stock.realReturnStartDate',
            placeholder2:'stock.realReturnEndDate',
        },
        {
            // name:'order.orderSource', // 车架号
            key:'attribute1',
            type:'input',
            width:'200px',
            allowClear:true,
            placeholder:'order.frameNumber',
        },
    ]
}

// 退货信息
const AddForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'150px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'returnExchange.backReasonType', // 退换货原因类型
            key:'back_reason_type', 
            type:'select',
            required:true,
            width:'420px',
            placeholder:'base.select',
        },
        {
            name:'returnExchange.backReason', // 退换货原因
            key:'back_reason',
            type:'textarea',   
            allowClear:true,
            required:true,
            showWordLimit:true,
            maxLength:150,
            width:'420px',
            placeholder:'base.input',
        },
        {
            name:'returnExchange.backTimestamp', // 退货时间
            key:'back_timestamp',
            type:'date',   
            allowClear:true,
            required:true,
            show:true,
            width:'420px',
        },
        {
            name:'returnExchange.courierType', // 退货物流公司
            key:'courier_type',
            type:'select',   
            allowClear:true,
            // required:true,
            // disabled:true,
            width:'420px',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'returnExchange.courierNo', // 退货物流单号
            key:'courier_no',
            type:'input',   
            allowClear:true,
            disabled:true,
            // required:true,
            width:'420px',
            placeholder:'base.input',
        },
        {
            name:'returnExchange.ibsVerificationType', // IBS验证方案类型
            key:'ibs_verification_type',
            type:'select',
            width:'420px',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'returnExchange.ibsVerificationPlan', // IBS验证方案描述
            key:'ibs_verification_plan', 
            type:'textarea',   
            allowClear:true,
            showWordLimit:true,
            maxLength:250,
            width:'420px',
            placeholder:'base.input',
        },
    ]
}

// 产品列表查询
const ProductQueryForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'30px',
    formData:{},
    formField:[
        {
            // name:'order.orderSource', // 产品名称
            key:'name',
            type:'input',
            width:'330px',
            allowClear:true,
            placeholder:'order.productName',
        },
        {
            // name:'order.sku', // SKU
            key:'sku',
            type:'select',
            width:'330px',
            allowClear:true,
            placeholder:'order.sku',
            options:[]
        },
        {
            // name:'order.inventoryCode', // 物料编码
            key:'inventory_code',
            type:'select',
            width:'330px',
            allowClear:true,
            placeholder:'order.inventoryCode',
            options:[]
        },
    ]
}

QueryForm.formField.forEach(item=>{
    QueryForm.formData[item.key] = ''
})

AddForm.formField.forEach(item=>{
    AddForm.formData[item.key] = ''
})

ProductQueryForm.formField.forEach(item=>{
    ProductQueryForm.formData[item.key] = ''
})

export {
    QueryForm,
    AddForm,
    ProductQueryForm
}